import React from 'react';
import { Toast } from 'antd-mobile';
import { ErrorModel,isErrorHttp } from '../common/error';


export const isErrorMobile = <T extends ErrorModel>(res: T,options:{codeKey?:keyof ErrorModel['data'],codeValue?:string,messageKey?:keyof ErrorModel['data']} = {}) => {
  const {codeKey = 'code',codeValue = 100,messageKey = 'message'  } = options
  const error = isErrorHttp(res)
  if(error.isError){
    Toast.show({
      icon: 'fail',
      content: error.message
    });
    return true
  }
  let businessData = res.data || {}
  if (businessData[codeKey] != codeValue) {
    console.error(businessData)
    Toast.show({
      icon: 'fail',
      content: businessData[messageKey]
    });
    return true;
  }
  return false;
};
/** code不未100的错误接口 */
export const isErrorMobile100 = <T extends ErrorModel>(res: T) => {
  return isErrorMobile(res,{codeValue:"100"})
}